import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchProducts = createAsyncThunk("products/fetch", async () => {
  const response = await API.get("/products")

  return response.data.products
})

export const fetchProduct = createAsyncThunk(
  "product/fetch",
  async (values: { product_id: number }) => {
    const response = await API.get(`/products/${values.product_id}`)
    return response.data.product
  },
)
